import { isTablet } from 'utils/general';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { trackBannerView, trackBannerClick } from 'lib/tracking';
import inViewport from 'in-viewport';

export default {
  props: ['id', 'url', 'index', 'name', 'selected', 'blocks', 'prevIndex'],
  data() {
    return {
      isActive: false,
      translatePosition: 0,
      positionLeft: 40,
      mediaWidth: 0,
      isTablet: isTablet(),
      rightDirection: true,
      offset: 40,
    };
  },
  mounted() {
    this.isActive = this.selected;
    on(window, 'resize', debounce(this.onResize, 300));

    if(this.blocks) {
      this.blocks.forEach(async(banner) => {
        inViewport(banner.$el, this.handleBannerViewTracking);
      })
    }
  },
  computed: {
    stepStyle() {
      if (this.isTablet) return '';
      if (this.selected) {
        const styles = this.rightDirection
          ? `transform: translateX(${this.translatePosition}px); left: ${this.positionLeft}px`
          : `transform: translateX(-${this.translatePosition}px); left: ${this.positionLeft}px`;

        return styles;
      }
    },
  },
  methods: {
    handleBannerViewTracking(banner) {
      const index = banner.dataset.index;
      trackBannerView({
        id: this.blocks[index].id,
        name: this.blocks[index].name,
        location: 'home/routine section',
        shopify_module_name: 'animated step'
      })
    },
    selectBlock(selectedBlockIndex) {
      if (this.prevIndex === selectedBlockIndex) {
        this.$emit('set-active', 0);
        this.translatePosition = 0;
        this.positionLeft = this.offset;
      }

      if (this.prevIndex !== selectedBlockIndex) {
        this.$emit('set-active', this.index);
        if (this.isTablet) {
          this.$nextTick(() => {
            const headerOffset = 60;
            const elementPosition =
              this.blocks[this.index].$el.getBoundingClientRect().top;
            const offsetPosition =
              elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          });
        }

        this.mediaWidth = this.blocks[this.index].$refs.media.offsetWidth;
        this.translatePosition = this.mediaWidth;

        if (selectedBlockIndex > this.prevIndex) {
          //left to right
          this.rightDirection = true;
          this.positionLeft = Math.abs(
            this.mediaWidth * (this.index - 1) + this.offset,
          );
        } else {
          //right to left
          this.rightDirection = false;
          this.positionLeft = this.mediaWidth * (this.index + 1) + this.offset;
        }
      }
    },
    onResize() {
      this.isTablet = isTablet();
      if (!this.isTablet) this.selectBlock(0);
    },

    onCTAClick() {
      trackBannerClick({id: this.id, name: this.name, location: 'home/routine section'});
      window.location.href = this.url;
    }
  },
  template: `
  <div><slot></slot></div>
`,
};
